import * as updateTerritoryById from "@/api/territories/update";

export default {
	namespaced: true,
	state: {
		territory: {},
		id: "",
		error: null,
	},
	getters: {
		readTerritory: (state) => state.territory,
		readId: (state) => state.id,
		readError: (state) => state.error,
	},
	mutations: {
		SET_TERRITORY(state, payload) {
			state.territory = payload;
		},
		SET_ID(state, payload) {
			state.id = payload;
		},
		SET_ERROR(state, payload) {
			state.error = payload;
		},
	},
	actions: {
		async updateTerritory({ commit, getters, rootGetters }) {
			const token = rootGetters['loginStore/readToken'];
			const updateTerritoryRes = await updateTerritoryById
				.updateTerritory(token,getters.readId, getters.readTerritory)
				.then(() => {
					return true;
				})
				.catch((error) => {
					if (error.response) {
						let message =
							error.response.data.message ||
							error.response.data.detail[0].msg;
						message == "Token expired"
							? commit("loginStore/SET_ACCESS_TOKEN", null, {
									root: true,
							  })
							: message
							? commit("SET_ERROR", message)
							: commit("SET_ERROR", "Algo salió mal");
					} else {
						console.log(error);
						commit("SET_ERROR", error);
					}
				});

			return updateTerritoryRes;
		},
	},
};
